export default __webpack_public_path__ + "static/media/segre23.350e9fef.jpg";